import styled from 'styled-components';

export const ChartLine = styled.line`
  shape-rendering: crispEdges;
  stroke: ${(p) => (p.dashed ? '#ddd' : p.theme.colors.greyblue)};
  stroke-width: ${(p) => (p.dashed ? 1 : 1)};
  stroke-dasharray: ${(p) => (p.dashed ? '2 2' : 'none')};
`;

export const ChartLabel = styled.text`
  font-size: 12px;
`;

export default {
  ChartLine,
  ChartLabel,
};
